import React from 'react'

import { Block, Typography } from '@xprog/prensa'

import { SubtitleProps } from './Subtitle.types'

const Subtitle = (props: SubtitleProps) => {
  return (
    <Typography
      as={props.as}
      css={props.customCss}
      variant={props.variant}>
      {props.value || props.children}
    </Typography>
  )
}

Subtitle.defaultProps = {
  as: 'h2',
  variant: 'default-heading-2xl'
}

export default Subtitle
